export default __webpack_public_path__ + "f9653307833624f68750b062a8c801c7.svg";